import { useQuery } from '@tanstack/react-query';
import qs from 'qs';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';

type GetActionsReturn = {
  [key: string]: boolean;
};

export enum Actions {
  ACCOUNTS_READ = 'accounts:read',
  ACCOUNTS_WRITE = 'accounts:write',
  CONTACTS_READ = 'contacts:read',
  CONTACTS_WRITE = 'contacts:write',
  EMPLOYEES_READ = 'employees:read',
  EMPLOYEES_WRITE = 'employees:write',
  EVENTS_READ = 'events:read',
  EVENTS_WRITE = 'events:write',
  TASKS_READ = 'tasks:read',
  TASKS_WRITE = 'tasks:write',
  EVENT_TEMPLATES_READ = 'event_templates:read',
  EVENT_TEMPLATES_WRITE = 'event_templates:write',
  EMAIL_TEMPLATES_READ = 'email_templates:read',
  EMAIL_TEMPLATES_WRITE = 'email_templates:write',
  TASK_TEMPLATES_READ = 'task_templates:read',
  TASK_TEMPLATES_WRITE = 'task_templates:write',
  ORGANIZATION_READ = 'organizations:read',
  INTEGRATIONS_WRITE = 'integrations:write',
  INTEGRATIONS_READ = 'integrations:read',
  ORGANIZATION_WRITE = 'organizations:write',
  PREFERENCES_WRITE = 'preferences:write',
  USER_ROLES_READ = 'user_roles:read',
  USER_ROLES_WRITE = 'user_roles:write',
  REPORT_READ = 'reports:read'
}

type UseGetAllActionsProps = {
  actions: string[]; // should be one of the values of the Actions enum above
  enabled?: boolean;
};

export const fetchActions = async ({ actions }: UseGetAllActionsProps) => {
  const response = await CustomAxios.get<GetActionsReturn>(`permissions/actions-check`, {
    params: { actions },
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: 'brackets' });
    },
  });
  const { data } = response;
  return data;
};

export function useGetAllActions({ actions, enabled }: UseGetAllActionsProps) {
  const query = useQuery({
    enabled,
    queryKey: [queryKeys.allActions, actions],
    queryFn: () => fetchActions({ actions }),
  });
  return query;
}
